import type { LanguageCode } from "../state/i18n";

// Languages we translate the platform into, but that have no content outside of it, e.g. on the pages we link to
export const FALLBACK_LANGUAGES = {
  ca: "es",
} as const satisfies Partial<Record<LanguageCode, LanguageCode>>;

/** Resolves a language to the closest one available outside the platform, e.g. on the pages we link to */
export const resolveFallbackLanguage = (language: LanguageCode): LanguageCode =>
  FALLBACK_LANGUAGES[language as keyof typeof FALLBACK_LANGUAGES] ?? language;

const TEMPLATE_LOCALES = {
  en: "en-GB",
  nl: "nl-NL",
  de: "de-DE",
  es: "es-ES",
  fr: "fr-FR",
  pt: "pt-PT",
} as const satisfies Partial<Record<LanguageCode, string>>;

// Templates are stored with a full locale, so we have to map bare language codes to their full locale
export const resolveTemplateLocale = (language: LanguageCode): string =>
  TEMPLATE_LOCALES[resolveFallbackLanguage(language) as keyof typeof TEMPLATE_LOCALES] ?? TEMPLATE_LOCALES.en;
